/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */

import React, { useEffect } from 'react';
import HotelDetailsV2 from './HotelDetailsV2';
import './HotelDetailsPage.scss';
import {
  hideHeaderMenu,
  showHeaderMenu,
} from '../../../shared/helper-utils/appUtils';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import HotelDetails from './HotelDetails';

function HotelDetailsPage() {
  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);
  return (
    <section className="hotel-details-page">
      {getUserAgentId() === 'FB71225' ? <HotelDetails /> : <HotelDetailsV2 />}
    </section>
  );
}

export default HotelDetailsPage;
